import {
  addToMultiMarket,
  cFactor,
  checkIncludeMultiMarket,
  EventDTO,
  formatTime,
  getCashoutBet,
  getMarketStatus,
  getOutcomeId,
  getTotalPL,
  langData,
  MarketNotification,
  MatchOddsDTO,
  MatchOddsRunnerDTO,
  removeToMultiMarket,
  setAlertMsg,
  setLoading,
  showToast,
  useAppDispatch,
  useAppSelector,
  UserBet,
  addExchangeBet,
  PlaceBetRequest,
} from "@hypexone/uicore";
import React, { useEffect, useState } from "react";
import MarqueeText from "../../MarqueeText/MarqueeText";
import { IMultiMarket, useMarketLocalState } from "../../../../utils/hooks/storage.hooks";
import MarketsTitle from "../market-table/MarketsTitle";
import MarketTableHeading from "../market-table/MarketTableHeading";
import MatchOddsRow from "./MatchOddsRow";
import Button from "../../shared/Button/Button";
import { BRAND_DOMAIN } from "../../../../constants/Branding";
import Modal from "../../shared/ModalComponent";
import { API_CLIENT } from "../../../../App.utils";
import { colors } from "../../../../styles/colors";
import PinIconGray from "../../../../assets/icons/events-icons/pin-icon-gray.svg";
import PinIconGreen from "../../../../assets/icons/events-icons/pin-icon-green.svg";
import InfoIconRoundedWhite from "../../../../assets/icons/info-icon-rounded-white.svg";
import { isMobile } from "react-device-detect";
import Popup from "../../shared/ModalComponent";
import OneClickBettingCountdown from "../../one-click-betting/OneClickBettingCountdown";

export type CashoutInfo = {
  selectionId: string;
  betType: any;
  oddValue: number;
  stakeAmount: number;
};

interface MatchOddsProps {
  eventData: EventDTO;
  secondaryMatchOdds: MatchOddsDTO[];
  loggedIn?: boolean;
  exposureMap: any;
  setBetStartTime?: Function;
  setAddNewBet?: Function;
  isMultiMarket?: boolean;
  marketNotifications?: MarketNotification[];
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  showMatchOdds: boolean;
  showSecondaryMatchOdds: boolean;
}

const MatchOdds: React.FC<MatchOddsProps> = ({
  eventData,
  secondaryMatchOdds,
  isMultiMarket,
  exposureMap,
  setAddNewBet,
  setBetStartTime,
  marketNotifications,
  showMatchOdds,
}) => {
  const dispatch = useAppDispatch();
  const { selectedEventType } = useAppSelector((state) => state.catalog);
  const { bets, openBets, isOneClickBettingLoading, bettingInprogress } = useAppSelector((state) => state.betSlip);
  const [confirmCashout, setConfirmCashout] = useState<boolean>(false);
  const eventCashoutEnabled =
    (eventData as EventDTO & { cashoutEnabled?: boolean })?.cashoutEnabled !==
    false;
  useEffect(() => {
    if (!eventCashoutEnabled && confirmCashout) {
      setConfirmCashout(false);
    }
  }, [eventCashoutEnabled, confirmCashout]);
  const [isCashoutProcessing, setIsCashoutProcessing] = useState<boolean>(false);
  let [matchOddsData, setMatchOddsData] = useState<MatchOddsDTO>();
  const [coMarket, setCoMarket] = useState<MatchOddsDTO>(null);
  const disabledStatus = ["suspended", "closed", "suspended-manually"];
  const [selectedRow, setSelectedRow] = useState<string>("");
  const [notifications, setNotifications] = useState<Map<String, string>>(
    new Map()
  );
  const [openBetsMap, setOpenBetsMap] = useState<Map<String, UserBet[]>>(
    new Map()
  );
  const { loading } = useAppSelector((state) => state.auth);
  // Add these inside your component, before the return block
  const [isPopupVisible, setPopupVisible] = useState(false);
  const { loggedIn } = useAppSelector((state) => state.auth);
  const cashoutEnabled = useAppSelector((state) => state.common.domainConfig?.cashoutEnabled === true);
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();

  // Cash-out calculation functions
  const getHighAndLowRiskRunners = (runners) => {
    let highRiskRunner = runners[0]?.runnerId;
    let lowRiskRunner = runners[1]?.runnerId;

    if (runners[1]?.userRisk < runners[0]?.userRisk) {
      [highRiskRunner, lowRiskRunner] = [lowRiskRunner, highRiskRunner];
    }

    return { highRiskRunner, lowRiskRunner };
  };

  const getOdds = (highRiskRunner, lowRiskRunner, runners) => {
    let odds = {
      highRiskBackPrice: 0,
      highRiskLayPrice: 0,
      lowRiskBackPrice: 0,
      lowRiskLayPrice: 0,
    };

    runners.forEach((runner) => {
      if (runner.runnerId === highRiskRunner) {
        odds.highRiskBackPrice = runner?.backPrices[0]?.price || 0;
        odds.highRiskLayPrice = runner?.layPrices[0]?.price || 0;
      }
      if (runner.runnerId === lowRiskRunner) {
        odds.lowRiskBackPrice = runner?.backPrices[0]?.price || 0;
        odds.lowRiskLayPrice = runner?.layPrices[0]?.price || 0;
      }
    });

    return odds;
  };

  const getFavRunner = (riskRunners, odds) => {
    const { highRiskRunner, lowRiskRunner } = riskRunners;
    const {
      highRiskBackPrice,
      lowRiskBackPrice,
      highRiskLayPrice,
      lowRiskLayPrice,
    } = odds;

    if (highRiskBackPrice > 1.0 && lowRiskBackPrice > 1.0) {
      return lowRiskBackPrice < highRiskBackPrice
        ? lowRiskRunner
        : highRiskRunner;
    }
    if (
      (highRiskBackPrice > 1.0 && highRiskBackPrice < 2.0) ||
      highRiskLayPrice >= 2.0
    ) {
      return highRiskRunner;
    }
    if (
      (lowRiskBackPrice > 1.0 && lowRiskBackPrice < 2.0) ||
      lowRiskLayPrice >= 2.0
    ) {
      return lowRiskRunner;
    }

    return highRiskRunner; // Default case
  };

  const getPayoutMap = (runners, key) => {
    const payoutMap = new Map();

    runners.forEach((runner) => {
      const runnerId = runner?.runnerId;

      openBetsMap.get(key)?.forEach((bet) => {
        const outcomeMatch = runnerId === bet.outcomeId;
        const betTypeBack = bet.betType === "BACK";
        const payout = bet.oddValue * bet.stakeAmount;

        if ((outcomeMatch && betTypeBack) || (!outcomeMatch && !betTypeBack)) {
          payoutMap.set(runnerId, (payoutMap.get(runnerId) || 0) + payout);
        }
      });
    });

    return payoutMap;
  };

  const getResponse = (riskRunners, favRunner, odds, payoutDiff) => {
    const isBackBet = riskRunners?.highRiskRunner === favRunner;
    const runnerId = isBackBet
      ? riskRunners?.highRiskRunner
      : riskRunners?.lowRiskRunner;
    const betType = isBackBet ? "BACK" : "LAY";
    const oddValue = isBackBet
      ? odds?.highRiskBackPrice
      : odds?.lowRiskLayPrice;

    let stake = Math.round((payoutDiff / oddValue) * 100) / 100;
    return { runnerId, betType, oddValue, stake, profit: Infinity };
  };

  const calCashout = (market: MatchOddsDTO) => {
    // Proceed only for markets with 2 runners
    const key = `${market.marketId}:${market.marketName}`;

    const risk = exposureMap[key];
    if (!risk) {
      return {
        runnerId: "",
        betType: "",
        oddValue: 0,
        stake: 0,
        profit: Infinity,
      };
    }
    // Retrieve high and low-risk runners
    const riskRunners = getHighAndLowRiskRunners(risk);

    // Calculate payout differences
    const payoutMap = getPayoutMap(risk, key);

    // Get odds for high and low-risk runners
    const odds = getOdds(
      riskRunners?.highRiskRunner,
      riskRunners?.lowRiskRunner,
      market.runners
    );

    // Determine the favorite runner
    const favRunner = getFavRunner(riskRunners, odds);

    // Calculate payout difference
    const payoutDiff =
      (payoutMap.get(riskRunners?.lowRiskRunner) || 0) -
      (payoutMap.get(riskRunners?.highRiskRunner) || 0);

    let response = getResponse(riskRunners, favRunner, odds, payoutDiff);
    for (let rn of risk) {
      if (rn.runnerId != response.runnerId && response.stake != 0) {
        let profit = +(response.stake - Math.abs(rn?.userRisk));
        if (response.betType === "BACK") {
          profit = -1 * profit;
        }
        response = { ...response, profit: +(profit / cFactor).toFixed(2) };
      }
    }

    // Determine the cash-out response
    return response;
  };

  const getCashoutProfit = (market: MatchOddsDTO) => {
    // Proceed only for markets with 2 runners
    if (market?.runners?.length !== 2) return 0;

    const key = `${market.marketId}:${market.marketName}`;

    if (!openBetsMap.has(key) || openBetsMap.get(key).length == 0) return 0;

    const response = calCashout(market);

    return response.profit || 0;
  };

  const autoCashout = async () => {
    if (coMarket == null || !eventCashoutEnabled) return;
    setIsCashoutProcessing(true);
    const response = calCashout(coMarket);

    if (response.oddValue == 0) {
      setIsCashoutProcessing(false);
      return;
    }

    const payload = {
      sportId: eventData.sportId,
      seriesId: eventData.competitionId,
      seriesName: eventData.competitionName,
      eventId: eventData.eventId,
      eventName: eventData.eventName,
      eventDate: eventData.openDate,
      marketId: coMarket.marketId,
      marketName: coMarket.marketName,
      marketType: "MO",
      outcomeId: response.runnerId,
      betType: response.betType,
      oddValue: +response.oddValue.toFixed(2),
      amount: +(response.stake / cFactor).toFixed(2),
      outcomeDesc: getOutcomeId(response.runnerId, coMarket.runners),
      sessionPrice: -1,
      srEventId: eventData.eventId,
      srSeriesId: eventData.competitionId,
      srSportId: eventData.sportId,
      oddLimt: coMarket?.marketLimits?.maxOdd.toString(),
      mcategory: "ALL",
    };

    if (payload.amount < 100) {
      setAlertMsg({
        type: 'error',
        message:
          langData?.['minimum_stake_txt'] +
          ' ' +
          100 + '.'
      });
      dispatch(setLoading(true));
      setIsCashoutProcessing(false);
      return;
    } else if (payload.amount > coMarket?.marketLimits?.maxStake) {
      setAlertMsg({
        type: "error",
        message:
          (langData?.["maximum_stake_amount"] || "Your bet amount") +
          " " +
          payload.amount +
          " " +
          (langData?.["max_stakeamount"] || "exceeds max stake amount") +
          " " +
          coMarket?.marketLimits?.maxStake +
          ".",
      });
      dispatch(setLoading(false));
      setIsCashoutProcessing(false);
      return;
    }

    try {
      const response = await API_CLIENT.post(`/bs/place-matchodds-bet`, payload, {
        headers: {
          Authorization: sessionStorage.getItem("jwt_token"),
        },
        timeout: 1000 * 20,
      });

      if (response.status === 200) {
      }
    } catch (error) {
      setAlertMsg({
        type: "error",
        message: error?.response?.data?.message,
      });
    }
    dispatch(setLoading(false));
    setIsCashoutProcessing(false);
  };

  const handleMultiMarket = (
    competitionId: string,
    eventId: string,
    marketId: string,
    providerName: string,
    sportId: string,
    isAdd: boolean
  ) => {
    if (loggedIn) {
      if (isAdd) {
        addToMultiMarket(competitionId, eventId, marketId, providerName, sportId);
        marketId &&
          setMultiMarketData((prevState: IMultiMarket[]) => [
            ...prevState,
            { competitionId, eventId, marketId, providerName, sportId },
          ]);
      } else {
        removeToMultiMarket(eventId, marketId);
        marketId &&
          setMultiMarketData((prevState) => {
            const data = [...prevState];
            const index = data.findIndex(
              (itm) => itm.eventId === eventId && itm.marketId === marketId
            );
            if (index > -1) data.splice(index, 1);
            return data;
          });
      }
    } else {
      dispatch(
        showToast({
          type: "error",
          message: "Please login",
        })
      );
    }
  };

  const openPopup = () => setPopupVisible(true);
  const closePopup = () => setPopupVisible(false);

  // const [open, setOpen] = useState<String[]>([]);
  useEffect(() => {
    let moMap = new Map();
    openBets
      .filter((b) => b.marketType == "MATCH_ODDS")
      .forEach((bet) => {
        const key = `${bet.marketId}:${bet.marketName}`;
        if (moMap.has(key)) {
          let boBets: UserBet[] = moMap.get(key);
          boBets.push(bet);
          moMap.set(key, boBets);
        } else {
          moMap.set(key, [bet]);
        }
      });
    setOpenBetsMap(moMap);
  }, [openBets]);

  useEffect(() => {
    if (eventData !== null) {
      setMatchOddsData(eventData?.matchOdds);
    }
  }, [eventData]);

  const isHaveCashOut = (matchOddsData: MatchOddsDTO) => {
    if (matchOddsData?.runners?.length !== 2) {
      return false;
    }

    if (openBets?.length === 0) {
      return false;
    }

    // Get the market specific bets
    const op = openBets?.filter((bet: UserBet) => {
      return bet.marketId === matchOddsData.marketId;
    });

    return op?.length > 0 ? true : false;
  };

  useEffect(() => {
    if (marketNotifications) {
      const map = new Map();
      marketNotifications.forEach((msgObj) => {
        map.set(msgObj.marketId, msgObj.message);
      });
      setNotifications(map);
    }
  }, [marketNotifications]);

  const minStakeByCurrency = matchOddsData?.marketLimits?.minStake
    ? matchOddsData?.marketLimits?.minStake / cFactor
    : 0;

  const maxStakeByCurrency = matchOddsData?.marketLimits?.maxStake
    ? matchOddsData?.marketLimits?.maxStake / cFactor
    : 0;
  const rules = [
    "cricket_match_odds",
    "tennis_match_odds",
    "football_match_odds",
    "football_under_over_goals"
  ];
  const highLightedIndices = [];
  const getOpenBetsPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    if (exposureMap && exposureMap[`${marketId}:${marketName}`]) {
      for (let rn of exposureMap[`${marketId}:${marketName}`]) {
        if (rn.runnerId === runner.runnerId) {
          return rn.userRisk / cFactor;
        }
      }
    }
    return null;
  };


  const getOpenBetsPLInArray = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let pl = getOpenBetsPL(marketId, marketName, runner);
    return pl ? [pl] : [];
  };

  return (
    <>
      {matchOddsData?.runners?.length &&
        matchOddsData?.runners?.length > 0 &&
        matchOddsData.status.toLowerCase() !== "closed" ? showMatchOdds && (
          !isMultiMarket ||
            checkIncludeMultiMarket(
              multiMarketData,
              matchOddsData.marketId
              //   eventData.eventId
            ) ? (
            <div className="relative flex flex-col w-full">
              {((isOneClickBettingLoading || bettingInprogress) &&
                bets?.[0]?.marketName ===
                  matchOddsData?.marketName &&
                bets?.[0]?.marketId === matchOddsData?.marketId) || 
                (isCashoutProcessing && coMarket?.marketId === matchOddsData?.marketId) ? (
                  <OneClickBettingCountdown
                    delay={matchOddsData?.marketLimits?.delay || 0}
                  />
              ) : null}

              <div className="flex items-center justify-between w-full bg-blue4 px-4 py-2 text-xs text-white font-bold">
                <div className="flex items-center">
                  {!checkIncludeMultiMarket(multiMarketData, matchOddsData.marketId) ? (
                    <span title="Add To Multi Markets">
                      <img
                        src={PinIconGray}
                        alt="multipin"
                        className="multi-add-icon cursor-pointer max-h-[22px]"
                        onClick={(e) => {
                          e.stopPropagation();
                          multiMarketData?.length < 10 &&
                            handleMultiMarket(
                              eventData?.competitionId,
                              eventData?.eventId,
                              matchOddsData.marketId,
                              eventData?.providerName,
                              eventData?.sportId,
                              true
                            );
                        }}
                      />
                    </span>
                  ) : (
                    <span title="Remove From Multi Markets">
                      <img
                        src={PinIconGreen}
                        alt="multipin"
                        className="multi-remove-icon cursor-pointer max-h-[22px]"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMultiMarket(
                            eventData?.competitionId,
                            eventData?.eventId,
                            matchOddsData.marketId,
                            eventData?.providerName,
                            eventData?.sportId,
                            false
                          );
                        }}
                      />
                    </span>
                  )}

                  <div className="ml-2 flex items-center">
                    <div>{matchOddsData?.marketName.toUpperCase()}</div>
                    {cashoutEnabled && eventCashoutEnabled && isHaveCashOut(matchOddsData) ? (
                      <div className="flex items-center px-1 space-x-2">
                        <Button

                          className={`px-2 tracking-tighter text-black leading-normal relative overflow-hidden text-[10px] transition duration-150 ease-in-out bg-[yellow] rounded-md text-center shadow-[inset_-12px_-8px_40px_#46464620] flex items-center justify-center flex-row h-fit py-1 cursor-pointer ${getCashoutProfit(matchOddsData) >= 0 ? "profit" : "loss"
                            }`}
                          disabled={
                            !isHaveCashOut(matchOddsData) ||
                            disabledStatus.includes(
                              matchOddsData.status.toLowerCase()
                            ) ||
                            matchOddsData.suspend === true ||
                            !(
                              `${matchOddsData?.marketId}:${matchOddsData?.marketName}` in
                              exposureMap
                            ) ||
                            getCashoutProfit(matchOddsData) == Infinity
                          }
                          loading={loading}
                          onClick={() => {
                            setCoMarket(matchOddsData);
                            setConfirmCashout(true);
                          }}
                        >
                          cashout
                          {getCashoutProfit(matchOddsData) != Infinity
                            ? `: ₹${getCashoutProfit(matchOddsData)}`
                            : ""}
                        </Button>
                        <i className="fas fa-info-circle"></i>
                      </div>
                    ) : null}
                    <div className="ml-4 cursor-pointer">
                      <img
                        onClick={openPopup}
                        src={InfoIconRoundedWhite}
                        alt="info-icon"
                        className="h-[13px] w-[13px] min-w-[13px]"
                      />
                    </div>
                  </div>

                  {secondaryMatchOdds &&
                    ["7", "4339"].includes(selectedEventType?.id) && (
                      <span className="market-start-time">
                        {formatTime(matchOddsData?.marketTime || new Date())}
                      </span>
                    )}

                  {["7", "4339"].includes(selectedEventType?.id) && (
                    <span
                      className={
                        getMarketStatus(matchOddsData?.marketTime || new Date()) === "OPEN"
                          ? " bg-[green] web-view"
                          : " bg-[red] web-view"
                      }
                    >
                      {getMarketStatus(matchOddsData?.marketTime || new Date())}
                    </span>
                  )}

                  <span>
                    {isMultiMarket && !isMobile && (
                      <span className="pl-2">{eventData?.eventName}</span>
                    )}
                  </span>
                </div>

                <Modal
                  isOpen={isPopupVisible}
                  onClose={closePopup}
                  content={<div>Popup Content</div>}
                  title="Rules"
                // headerText={header}
                // highLightedIndices={highLightedIndices}
                >
                  {rules.map((point, index) => (
                    <div
                      key={index}
                      className={`p-[8px] border-b font-sans font-[450] border-gray-300 flex items-center text-[12px]  ${highLightedIndices.includes(index) ? "text-[#F1556C]" : " text-[#000]"
                        }`}
                    >
                      {langData?.[point] || point}
                    </div>
                  ))}
                </Modal>
              </div>


              <div className="flex flex-col px overflow-x-scroll bg-white  border border-solid border-neutral-200 max-md:max-w-full">
                <table className="w-full text-[14px] font-medium">
                  {/* <thead>
                  <tr className=" py-2 text-[14px] font-medium whitespace-nowrap h-[32px] bg-neutral-200 text-neutral-500 ">
                    <th className=" w-[70%] text-left pl-3">Markets</th>
                    <th className="  ">Back</th>
                    <th className=" ">Lay</th>
                  </tr>
                </thead> */}
                  <MarketTableHeading
                    title1="back"
                    title2="lay"
                    minStake={minStakeByCurrency}
                    maxStake={maxStakeByCurrency}
                  />
                  <tbody>
                    {matchOddsData?.status &&
                      matchOddsData?.runners
                        .filter(
                          (runner) => runner?.status.toLowerCase() !== "loser"
                        )
                        .map((runner, index) => (
                          <MatchOddsRow
                            key={index}
                            minStake={minStakeByCurrency}
                            maxStake={maxStakeByCurrency}
                            eventData={eventData}
                            marketName={matchOddsData?.marketName}
                            // marketLimits={marketLimits}
                            matchOddsData={matchOddsData}
                            runner={runner}
                            getOpenBetsPL={getOpenBetsPLInArray}
                            getTotalPL={getTotalPL}
                            disabledStatus={disabledStatus}
                            bets={bets}
                            selectedRow={selectedRow}
                            setSelectedRow={setSelectedRow}
                            setAddNewBet={setAddNewBet}
                            setBetStartTime={setBetStartTime}
                            exposure={exposureMap}
                          // open={open}
                          // setOpen={setOpen}
                          // index={index}
                          />
                        ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null
        ) : null}
      {/* Secondary Match Odds */}
      {secondaryMatchOdds?.length > 0 &&
        secondaryMatchOdds?.map((moData, idx) => (
          <React.Fragment key={idx}>
            {moData.status?.toLowerCase() !== "closed" &&
            !moData?.marketName?.toLowerCase().includes("who will win the match") ? (
              <>
                {!isMultiMarket ||
                  checkIncludeMultiMarket(
                    multiMarketData,
                    moData.marketId
                    //   eventData.eventId
                  ) ? (
                  <div className="relative flex flex-col w-full">
                    {((isOneClickBettingLoading || bettingInprogress) &&
                    bets?.[0]?.marketName === moData?.marketName &&
                    bets?.[0]?.marketId === moData?.marketId) ||
                    (isCashoutProcessing && coMarket?.marketId === moData?.marketId) ? (
                      <OneClickBettingCountdown
                        delay={moData?.marketLimits?.delay || 0}
                      />
                    ) : null}
                    
                    <div className="flex items-center justify-between w-full bg-blue4 px-4 py-2 text-xs text-white font-bold">
                      <div className="flex items-center">
                        {!checkIncludeMultiMarket(multiMarketData, moData.marketId) ? (
                          <span title="Add To Multi Markets">
                            <img
                              src={PinIconGray}
                              alt="multipin"
                              className="multi-add-icon cursor-pointer max-h-[22px]"
                              onClick={(e) => {
                                e.stopPropagation();
                                multiMarketData?.length < 10 &&
                                  handleMultiMarket(
                                    eventData?.competitionId,
                                    eventData?.eventId,
                                    moData.marketId,
                                    eventData?.providerName,
                                    eventData?.sportId,
                                    true
                                  );
                              }}
                            />
                          </span>
                        ) : (
                          <span title="Remove From Multi Markets">
                            <img
                              src={PinIconGreen}
                              alt="multipin"
                              className="multi-remove-icon cursor-pointer max-h-[22px]"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMultiMarket(
                                  eventData?.competitionId,
                                  eventData?.eventId,
                                  moData.marketId,
                                  eventData?.providerName,
                                  eventData?.sportId,
                                  false
                                );
                              }}
                            />
                          </span>
                        )}

                        <div className="ml-2 flex items-center">
                          <div>{moData?.marketName.toUpperCase()}</div>
                          {cashoutEnabled && eventCashoutEnabled && isHaveCashOut(moData) ? (
                            <div className="flex items-center px-1 space-x-2">
                              <Button
                                className={`px-2 tracking-tighter text-white leading-normal relative overflow-hidden text-[10px] transition duration-150 ease-in-out bg-cashout-btn-gradient rounded-md text-center shadow-[inset_-12px_-8px_40px_#46464620] flex items-center justify-center flex-row h-fit py-1 cursor-pointer ${getCashoutProfit(moData) >= 0 ? "profit" : "loss"
                                  }`}
                                disabled={
                                  !isHaveCashOut(moData) ||
                                  disabledStatus.includes(
                                    moData.status.toLowerCase()
                                  ) ||
                                  moData.suspend === true ||
                                  !(
                                    `${moData?.marketId}:${moData?.marketName}` in
                                    exposureMap
                                  ) ||
                                  getCashoutProfit(moData) == Infinity
                                }
                                loading={loading}
                                onClick={() => {
                                  setCoMarket(moData);
                                  setConfirmCashout(true);
                                }}
                              >
                                cashout
                                {getCashoutProfit(moData) != Infinity
                                  ? `: ₹${getCashoutProfit(moData)}`
                                  : "0"}
                              </Button>
                              <i className="fas fa-info-circle"></i>
                            </div>
                          ) : null}
                          <div className="ml-4 cursor-pointer">
                            <img
                              onClick={openPopup}
                              src={InfoIconRoundedWhite}
                              alt="info-icon"
                              className="h-[13px] w-[13px] min-w-[13px]"
                            />
                          </div>
                        </div>

                        {secondaryMatchOdds &&
                          ["7", "4339"].includes(selectedEventType?.id) && (
                            <span className="market-start-time">
                              {formatTime(moData?.marketTime || new Date())}
                            </span>
                          )}

                        {["7", "4339"].includes(selectedEventType?.id) && (
                          <span
                            className={
                              getMarketStatus(moData?.marketTime || new Date()) === "OPEN"
                                ? " bg-[green] web-view"
                                : " bg-[red] web-view"
                            }
                          >
                            {getMarketStatus(moData?.marketTime || new Date())}
                          </span>
                        )}

                        <span>
                          {isMultiMarket && !isMobile && (
                            <span className="pl-2">{eventData?.eventName}</span>
                          )}
                        </span>
                      </div>

                      <Modal
                        isOpen={isPopupVisible}
                        onClose={closePopup}
                        content={<div>Popup Content</div>}
                        title="Rules"
                      >
                        {rules.map((point, index) => (
                          <div
                            key={index}
                            className={`p-[8px] border-b font-sans font-[450] border-gray-300 flex items-center text-[12px]  ${highLightedIndices.includes(index) ? "text-[#F1556C]" : " text-[#000]"
                              }`}
                          >
                            {langData?.[point] || point}
                          </div>
                        ))}
                      </Modal>
                    </div>

                    <div className="flex flex-col px overflow-x-scroll bg-white border border-solid border-neutral-200 max-md:max-w-full">
                      <table className="w-full text-[14px] font-medium">
                        <MarketTableHeading
                          cashOutButton={
                            cashoutEnabled && eventCashoutEnabled && isHaveCashOut(moData) ? (
                              <div className="h-[28px]">
                                <Button
                                  color="primary"
                                  className="h-[28px] w--auto bg-[#b98eb1] text-[#fff] cursor-pointer px-2 flex items-center"
                                  disabled={
                                    disabledStatus.includes(
                                      moData.status.toLowerCase()
                                    ) ||
                                    moData.suspend === true ||
                                    !(
                                      `${moData?.marketId}:${moData?.marketName}` in
                                      exposureMap
                                    )
                                  }
                                  onClick={() => dispatch(getCashoutBet({ eventData: eventData, matchOddsData: moData }))}
                                >
                                  Cashout
                                </Button>
                              </div>
                            ) : null
                          }
                          title1="Back"
                          title2="Lay"
                          minStake={minStakeByCurrency}
                          maxStake={maxStakeByCurrency}
                        />
                        <tbody>
                          {idx === 0 &&
                            ["7", "4339"].includes(selectedEventType?.id) ? (
                            <label
                              className={
                                getMarketStatus(
                                  (moData as MatchOddsDTO)?.marketTime ||
                                  new Date()
                                ) === "OPEN"
                                  ? "profit mob-view"
                                  : "loss mob-view"
                              }
                            >
                              {getMarketStatus(
                                (moData as MatchOddsDTO)?.marketTime ||
                                new Date()
                              )}
                            </label>
                          ) : null}
                          {moData?.runners?.length > 0 &&
                            moData?.runners
                              .filter(
                                (runner) =>
                                  runner?.status?.toLowerCase() !== "loser"
                              )
                              .map((runner, idx2) => (
                                <MatchOddsRow
                                  key={idx2}
                                  minStake={
                                    moData?.marketLimits?.minStake
                                      ? moData?.marketLimits?.minStake /
                                      cFactor
                                      : 0
                                  }
                                  maxStake={
                                    moData?.marketLimits?.maxStake
                                      ? moData?.marketLimits?.maxStake /
                                      cFactor
                                      : 0
                                  }
                                  eventData={eventData}
                                  marketName="who will win the match"
                                  // marketLimits={marketLimits}
                                  matchOddsData={moData}
                                  runner={runner}
                                  getOpenBetsPL={getOpenBetsPLInArray}
                                  getTotalPL={getTotalPL}
                                  disabledStatus={disabledStatus}
                                  bets={bets}
                                  selectedRow={selectedRow}
                                  setSelectedRow={setSelectedRow}
                                  exposure={exposureMap}
                                // open={open}
                                // setOpen={setOpen}
                                // index={idx2}
                                />
                              ))}

                          {notifications.get(moData?.marketId) ? (
                            <tr>
                              <td colSpan={12} className=" overflow-hidden">
                                <MarqueeText
                                  text={notifications.get(moData?.marketId) ?? ""}
                                />
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
              </>
            ) : null}
          </React.Fragment>
        ))}

      <Modal
        title="Do you wish to perform cash out?"
        isOpen={confirmCashout}
        onClose={() => setConfirmCashout(false)}
      >

        <div className="grid grid-cols-2 w-full gap-x-2">
          {/* Cancel Button */}
          <Button
            type="button"
            onClick={() => setConfirmCashout(false)}
            className="leading-normal relative overflow-hidden transition duration-150 ease-in-out bg-transparent w-full px-2.5 py-1 border-[1px] border-primary rounded-[4px] flex items-center justify-center cursor-pointer"
          >
            <span className="text-text_Primary text-[16px] font-[700] font-lato">
              cancel
            </span>
          </Button>

          {/* Cashout Button */}
          <div className="w-full">
            <Button
              type="button"
              disabled={loading}
              onClick={() => {
                setLoading(true);
                autoCashout();
                setConfirmCashout(false);
              }}
              className="leading-normal relative overflow-hidden transition duration-150 ease-in-out bg-[#29ab2b] w-full h-[36px] min-h-[36px] px-2.5 py-1 border-[1px] border-success rounded-[4px] flex items-center justify-center cursor-pointer"
            >
              <span className="text-white text-[16px] font-[700] font-lato">
                cashout
              </span>
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MatchOdds;
